import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CalendarClockIcon, CheckCircle2Icon } from 'lucide-react';
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 24
  },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.1,
      duration: 0.6,
      ease: 'easeOut'
    }
  })
};
export function InsaneValueSection() {
  return <div className="grain-section w-full bg-gradient-to-br from-[#0d1117] via-[#1a1a2e] to-[#0f172a] px-6 py-16 md:py-24 overflow-hidden" data-id="element-112" data-mp="2ya2hql9lyy01">
      <div className="max-w-3xl mx-auto space-y-12 md:space-y-14" data-id="element-113" data-mp="2tag3c8i1nbpn">
        {/* Headline */}
        <div className="text-center space-y-4" data-id="element-114" data-mp="37z3wk84f39cf">
          <span className="inline-block bg-teal-500/20 border border-teal-500/40 text-teal-400 text-xs font-black tracking-widest uppercase px-4 py-1.5 rounded-full" data-id="element-115" data-mp="381yffv7s8m3q">
            Why This Is a No-Brainer
          </span>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-black tracking-tighter leading-[0.95] text-white" data-id="element-116" data-mp="3c20gq39lvdih">
            Here's What Makes This <span className="text-teal-400" data-id="element-117" data-mp="16exbqau3sh7c">INSANE</span>
            <br data-id="element-118" data-mp="1bcgqdbupqvzt" />
            <span className="text-white/70 text-2xl md:text-4xl font-bold" data-id="element-119" data-mp="1bbx9zzkpofnw">
              (And Why You'd Be CRAZY to Miss This)
            </span>
          </h2>
        </div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} custom={2} variants={fadeUp} className="overflow-hidden rounded-[2rem] border border-white/15 bg-[#111827] shadow-[0_24px_65px_rgba(0,0,0,0.28)]" data-id="element-120" data-mp="1lams9tgis24o">
          <div className="border-b border-white/10 px-7 py-8 text-center md:px-10 md:py-10" data-id="element-121" data-mp="1ua9s4atlozvm">
            <p className="text-xs font-black uppercase tracking-[0.22em] text-white/45" data-id="element-122" data-mp="1z3m6zt8h9sb6">
              What a Full Transformation Program Normally Costs
            </p>
            <p className="mt-5 font-display text-5xl font-black leading-none tracking-tight text-white md:text-7xl" data-id="element-123" data-mp="2910mnqmkud2f">
              $15,000 to $45,000+
            </p>
          </div>

          <div className="px-7 py-8 md:px-10 md:py-10" data-id="element-124" data-mp="dxc35ap3dfuq">
            <h3 className="font-display text-2xl font-black leading-tight text-white md:text-3xl" data-id="element-125" data-mp="dxu4glqm2k9i">
              Built for clients who need a longer period of hands-on program
              management.
            </h3>
            <ul className="mt-7 space-y-4" data-id="element-126" data-mp="mrqrs3vii2qi">
              {['Continual program updates as your biology and results change', 'Ongoing monitoring throughout the transformation process', 'Longer-term, hands-on management from your specialist'].map(item => <li key={item} className="flex items-start gap-4 rounded-2xl border border-white/10 bg-white/[0.05] p-5" data-id="element-127" data-mp="rp8ql1ftf1ks">
                  <CheckCircle2Icon className="mt-0.5 h-5 w-5 flex-shrink-0 text-teal-400" aria-hidden="true" data-id="element-128" data-mp="15n72m06nylx4" />
                  <span className="text-lg font-semibold leading-relaxed text-white/80" data-id="element-129" data-mp="11nerpgtss3ol">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} custom={3} variants={fadeUp} className="text-center" data-id="element-130" data-mp="33g2w3ti6gx5y">
          <p className="text-sm font-black uppercase tracking-[0.2em] text-teal-400" data-id="element-131" data-mp="2xc6e65x3inpc">
            But if you do not need that level of ongoing management...
          </p>
          <p className="mx-auto mt-4 max-w-2xl font-display text-2xl font-black leading-tight text-white md:text-4xl" data-id="element-132" data-mp="2ojmmxqj4vlej">
            You can get the transformation intelligence in a lighter delivery
            model.
          </p>
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} custom={4} variants={fadeUp} className="overflow-hidden rounded-[2rem] border border-teal-200 bg-white text-left shadow-[0_22px_60px_rgba(0,0,0,0.28)]" data-id="element-133" data-mp="2em879t51b0na">
          <div className="border-b border-teal-100 bg-teal-50 px-7 py-7 md:px-10" data-id="element-134" data-mp="3uzydp6jmm103">
            <h3 className="font-display text-2xl font-black leading-tight tracking-tight text-ink md:text-4xl" data-id="element-135" data-mp="3uxudaykxrk4k">
              <span className="text-teal-600" data-id="element-136" data-mp="1zwikplb6s7m2">
                Meeting With the Master: Advanced.
              </span>
              <span className="mt-2 block" data-id="element-137" data-mp="1uwxfwu9c551f">
                A 1-month "lite" version of our full Precision Cell™
                Transformation Programs.
              </span>
            </h3>
          </div>

          <div className="px-7 py-8 text-ink md:px-10 md:py-10" data-id="element-138" data-mp="1lxis62kjz8km">
            <div className="rounded-2xl border border-teal-200 bg-teal-50 px-6 py-6 md:px-7" data-id="element-139" data-mp="1gxo406s5wx39">
              <p className="text-lg font-semibold leading-[1.7] md:text-xl" data-id="element-140" data-mp="1c6xxurbwwq7i">
                From a true{' '}
                <span className="font-black text-teal-700" data-id="element-141" data-mp="177lbe7oydl5g">MASTER</span> of
                human biology who personally cares about your results and works
                with you directly to make{' '}
                <span className="font-black text-teal-700 underline decoration-teal-200 decoration-4 underline-offset-4" data-id="element-142" data-mp="y6ww79ntpeqz">
                  SURE you progress.
                </span>
              </p>
            </div>

            <ol className="mt-6 space-y-3" data-id="element-143" data-mp="34w8d6zpu991e">
              <li className="flex gap-4 rounded-2xl border border-black/[0.06] bg-white p-5 shadow-sm md:p-6" data-id="element-144" data-mp="34v5jkk14sshs">
                <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-teal-600 font-black text-white" data-id="element-145" data-mp="39wcugrykm7so">
                  1
                </span>
                <p className="pt-1 text-lg leading-relaxed md:text-xl" data-id="element-146" data-mp="3iuf2vskmw2pz">
                  We'll show you{' '}
                  <span className="font-black text-ink" data-id="element-147" data-mp="2m2uqfhwa48wv">
                    exactly what's wrong.
                  </span>
                </p>
              </li>
              <li className="flex gap-4 rounded-2xl border border-black/[0.06] bg-page-bg p-5 md:p-6" data-id="element-148" data-mp="2v4kpn9wekc57">
                <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-teal-600 font-black text-white" data-id="element-149" data-mp="2zx45kdikbjd6">
                  2
                </span>
                <p className="pt-1 text-lg leading-relaxed md:text-xl" data-id="element-150" data-mp="27f9npp3bgbph">
                  We'll direct you on the{' '}
                  <span className="font-black text-teal-700" data-id="element-151" data-mp="3apnqsz9a73ke">
                    exact steps to fix it.
                  </span>
                </p>
              </li>
              <li className="flex gap-4 rounded-2xl border border-black/[0.06] bg-white p-5 shadow-sm md:p-6" data-id="element-152" data-mp="3jjsej9t4byvp">
                <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-teal-600 font-black text-white" data-id="element-153" data-mp="3fhf9yoq3y70i">
                  3
                </span>
                <p className="pt-1 text-lg leading-relaxed md:text-xl" data-id="element-154" data-mp="2mt9o1ynbibz3">
                  We'll make it{' '}
                  <span className="font-black text-ink" data-id="element-155" data-mp="30tappgbepnfm">
                    as easy as possible
                  </span>{' '}
                  for you to do it (and personally connect you with our most
                  trusted vendors for quality and safety).
                </p>
              </li>
              <li className="flex gap-4 rounded-2xl border-2 border-teal-200 bg-teal-50 p-5 md:p-6" data-id="element-156" data-mp="b3yzz0ickxha">
                <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-teal-600 font-black text-white" data-id="element-157" data-mp="jk7zffkyhfoa">
                  4
                </span>
                <p className="pt-1 text-lg font-semibold leading-relaxed md:text-xl" data-id="element-158" data-mp="9mjr1mufg9nn">
                  We'll guide you with{' '}
                  <span className="font-black text-teal-700" data-id="element-159" data-mp="emfv1m34k137">
                    one month of extra, dedicated support
                  </span>{' '}
                  from your transformation specialist.
                </p>
              </li>
            </ol>
          </div>
        </motion.div>

        <motion.div id="advanced-price" initial="hidden" whileInView="visible" viewport={{
        once: true
      }} custom={5} variants={fadeUp} className="relative scroll-mt-28 overflow-hidden rounded-[2rem] border-2 border-teal-400 bg-white p-8 shadow-[0_22px_60px_rgba(14,165,233,0.2)] md:p-12" data-id="element-160" data-mp="slxmyabpvugs">
          <div className="text-center" data-id="element-161" data-mp="1q1lc5v40626c">
            <CheckCircle2Icon className="mx-auto h-8 w-8 text-teal-600" aria-hidden="true" data-id="element-162" data-mp="1q2mqc8gbf4sa" />
            <p className="mt-5 text-xs font-black uppercase tracking-[0.22em] text-teal-700" data-id="element-163" data-mp="3m4zm6d9tvnc1">
              Special Limited-Time Offer
            </p>

            <div className="mt-6" data-id="element-164" data-mp="3cd3kks8j9f32">
              <p className="text-xs font-black uppercase tracking-[0.16em] text-ink/40" data-id="element-165" data-mp="3ceepwwhmmuwa">
                Full Transformation Program
              </p>
              <p className="mt-2 font-display text-3xl font-black text-ink/35 line-through decoration-rose-500 decoration-[5px] md:text-5xl" data-id="element-166" data-mp="8xochwjptfkk">
                $15,000 to $45,000+
              </p>
            </div>

            <p className="mt-8 text-sm font-black uppercase tracking-[0.2em] text-ink/55" data-id="element-167" data-mp="3w12uy1z6qk7y">
              Your One-Time Investment
            </p>
            <p className="mt-3 font-display text-7xl font-black leading-none tracking-tight text-teal-700 md:text-8xl" data-id="element-168" data-mp="3r4vom82vn6ph">
              $5,000
            </p>
            <p className="mt-3 text-sm font-semibold text-ink/45" data-id="element-169" data-mp="2fmktpfytlq5x">
              Plus processing fee
            </p>

            <div className="mx-auto mt-7 max-w-md rounded-2xl border border-emerald-200 bg-emerald-50 px-6 py-5" data-id="element-170" data-mp="v74vdg093my6">
              <p className="text-xs font-black uppercase tracking-[0.18em] text-emerald-700" data-id="element-171" data-mp="104wlc4hc4yzq">
                Your Savings
              </p>
              <p className="mt-2 font-display text-2xl font-black text-emerald-700 md:text-3xl" data-id="element-172" data-mp="18wq9abz71bzc">
                $10,000 to $40,000+
              </p>
            </div>

            
          </div>

          <div className="mt-10 rounded-[1.75rem] border border-blue-400 bg-[#102a56] p-5 shadow-[0_18px_45px_rgba(30,64,175,0.3)] md:p-7" data-id="element-173" data-mp="1iuw82kppe1zz">
            <p className="text-center text-xs font-black uppercase tracking-[0.2em] text-blue-200" data-id="element-174" data-mp="1nvk4xn0m5d24">
              Ready to Secure Your Advanced Session?
            </p>
            <a href="https://go.peptidescienceinstitute.com/meeting-with-the-master-advanced" className="mt-4 inline-flex w-full items-center justify-center gap-3 rounded-2xl border-2 border-blue-300 bg-blue-600 px-7 py-5 text-center text-lg font-black text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.24),0_14px_30px_rgba(37,99,235,0.4)] transition-all duration-200 hover:-translate-y-1 hover:bg-blue-500 hover:shadow-[inset_0_1px_0_rgba(255,255,255,0.3),0_20px_38px_rgba(37,99,235,0.48)] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-blue-300/60 md:text-xl" data-id="element-175" data-mp="3pm44nfj9t3i5">
              Book Your Meeting With the Master: Advanced
              <ArrowRightIcon className="h-6 w-6" aria-hidden="true" data-id="element-176" data-mp="3r6wzdoqm5l1r" />
            </a>
            <p className="mt-4 text-center text-xs font-semibold tracking-wide text-blue-100/70" data-id="element-177" data-mp="3v77eps0apnta">
              One-time purchase · Secure booking
            </p>
          </div>
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} custom={5} variants={fadeUp} className="rounded-[2rem] border border-amber-300/35 bg-amber-300/10 p-7 md:p-10" data-id="element-178" data-mp="8so0pwf8ganc">
          <div className="flex flex-col gap-6 md:flex-row md:items-start" data-id="element-179" data-mp="irlkkm1prg00">
            <CalendarClockIcon className="h-9 w-9 flex-shrink-0 text-amber-300" aria-hidden="true" data-id="element-180" data-mp="23a5wg9zn1rb3" />
            <div data-id="element-181" data-mp="1y9i7dtuyzkji">
              <p className="text-xs font-black uppercase tracking-[0.2em] text-amber-300" data-id="element-182" data-mp="1y900m3aolnxc">
                This Will Not Stay Available
              </p>
              <h3 className="mt-3 font-display text-2xl font-black leading-tight text-white md:text-3xl" data-id="element-183" data-mp="1ocncrm1ti4ai">
                The last time we offered this was almost 6 months ago.
              </h3>
              <p className="mt-4 text-lg leading-relaxed text-white/70 md:text-xl" data-id="element-184" data-mp="2h09e0nnkowu7">
                After this intake period is over, Meeting With the Master:
                Advanced will close again. We are not keeping this format
                permanently available.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Closing Copy */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} custom={5} variants={fadeUp} className="space-y-4 text-center" data-id="element-185" data-mp="34s7yny8ww4k0">
          {["So if you've been stuck...", "If you've been spinning your wheels with \"experts\" who couldn't figure out what's wrong...", "And you want a precision roadmap built by people who've solved cases that stumped entire medical teams..."].map((line, i) => <p key={i} className={`text-lg md:text-xl leading-relaxed ${i === 2 ? 'font-semibold text-white text-xl md:text-2xl' : 'text-white/70 font-light'}`} data-id="element-186" data-mp="tb4um7my8mo7" data-mpi={i}>
              {line}
            </p>)}
          <p className="text-2xl md:text-3xl font-black text-teal-400 pt-2" data-id="element-187" data-mp="jcyvfxsj1un1">
            This is your shot.
          </p>
        </motion.div>

      </div>
    </div>;
}